// extracted by mini-css-extract-plugin
module.exports = {"SectionName":"index-module--SectionName--1KEvI","SurroundingText":"index-module--SurroundingText--3jZCu"};